<script>
	import { onMount, setContext } from "svelte";
	import { writable, get } from "svelte/store";

	import "./MenuItemTitle.scss";

	export let title = "";
	export let icon = null;
	export let materialIcon = null;
</script>

{#if title.length > 0}
	<div class="menu-item-title">
		<h1 >
			{#if icon != null}
				<img class="header-icon" alt={title} src={icon} />
			{/if}
			{#if materialIcon != null}
				<span class='material-icons header-icon'>{materialIcon}</span>
			{/if}
			{title}
		</h1>
		<!-- Context menu area. -->
		<div class='context-menu'>
			<slot/>
		</div>
	</div>
{/if}
